module.exports = __webpack_public_path__ + "img/gambia.eb0c7cba.svg";